import { SaleOrderTypeDto  } from "@gtpl/shared-models/masters";
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';


export class AllSaleOrderTypeResponseModel extends GlobalResponseObject {
    data?: SaleOrderTypeDto[];

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data /ProductDto[]
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: SaleOrderTypeDto[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}

